var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.523 144.53C230.712 142.859 231.867 140.167 231.569 137.431C231.272 134.695 229.565 132.313 227.069 131.151L91.4245 63.3553C88.911 62.0996 85.9261 62.2338 83.5356 63.7101C81.1451 65.1864 79.6899 67.7942 79.6896 70.6023V165.004C79.6179 168.093 81.3752 170.934 84.1724 172.251C126.281 192.615 190.308 180.274 228.523 144.53Z",
    fill: "url(#paint0_linear_10_31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.898 194.254C298.982 159.888 231.861 155.921 175.26 183.816L84.1718 229.328C81.4247 230.701 79.6893 233.506 79.689 236.575V330.96C79.6893 333.768 81.1445 336.376 83.535 337.852C85.9254 339.328 88.9104 339.463 91.4239 338.207C91.4239 338.207 345.592 211.228 351.949 208.036C354.589 206.749 356.26 204.065 356.249 201.129C356.238 198.193 354.548 195.522 351.898 194.254Z",
    fill: "url(#paint1_linear_10_31)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_31",
    x1: 207.59,
    y1: 181.685,
    x2: 105.513,
    y2: 86.5931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#8921C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_31",
    x1: 356.249,
    y1: 252.219,
    x2: 79.689,
    y2: 252.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#8921C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2784FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a8780c7c56ed91011c6e76bf3584fe94.svg";
export { ForwardRef as ReactComponent };